
import Splide from '@splidejs/splide';
Drupal.behaviors.tabs = {
  attach() {
    jQuery(document).ready(function(e) {
      jQuery('.tab-content-wrapper .tab-content-wrapper__inner .tab-items').each(function(){
        var item = jQuery(this).detach();
        jQuery('.tab-content-wrapper ul.tabs').append(item);
        jQuery(this).wrap('<li class="nav-tabs__list-item"></li>');
      }); 

      jQuery('.tab-content-wrapper .tab-content-wrapper__inner .tab-content').each(function(){
        var itemcontent = jQuery(this).detach();
        jQuery('.tab-content-wrapper .tab-content-section').append(itemcontent);
        jQuery(this).wrap('<div class="tab-content-item"></div>');
      }); 

      jQuery('.tab-content-wrapper ul.tabs .nav-tabs__list-item').each(function(index){
        jQuery(this).attr('rel','tabitem-'+index);
      });

      jQuery('.tab-content-wrapper .tab-content-item').each(function(index){
        jQuery(this).attr('class','tab-content-item tabitem-'+index);
      }); 

      
      jQuery('.tab-content-wrapper .nav-tabs__list-item:first-child, .tab-content-wrapper .tab-content-section .tab-content-item:first-child').addClass('active');

      jQuery('ul.tabs li.nav-tabs__list-item').on('click', function(e) {
        jQuery('ul.tabs li.nav-tabs__list-item').removeClass('active');
        jQuery(this).addClass('active');

       var tabcontent =  jQuery(this).attr('rel');
       jQuery('.tab-content-wrapper .tab-content-section .tab-content-item').removeClass('active');
       jQuery('.tab-content-wrapper .tab-content-section .tab-content-item').hide();
       jQuery('.'+tabcontent).addClass('active');
      jQuery('.'+tabcontent).show();
      });
    });
  },
};
